import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import carouselImage1 from '../assets/img/carousel.jpg';
import carouselImage2 from '../assets/img/carousel1.jpg';
import carouselImage3 from '../assets/img/carousel2.jpg';
import carouselImage4 from '../assets/img/carousel3.jpg';
import carouselImage5 from '../assets/img/carousel4.jpeg';
import atout from '../assets/img/atouts/Nantes.jpg';
import atout1 from '../assets/img/atouts/convaincre.JPG';
import atout2 from '../assets/img/atouts/unir.JPG';
import img1 from '../assets/img/propos/1.jpg';
import NavBar from './components/nav';
import Footer from './components/Footer';
import president from '../assets/img/president.jpg';
import CustomCursor from './components/CustomCursor'; // Importez le composant
import BtnFlottant from "./components/BtnFlottant"; // Import du composant

const Apropos = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    carouselImage2,
    carouselImage1,
    carouselImage4,
    carouselImage3,
    carouselImage5,
  ];

  // Fonction pour passer à la diapositive suivante
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
  };

  // Effet pour le défilement automatique
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Change de diapositive toutes les 5 secondes

    // Nettoyer l'intervalle lorsque le composant est démonté
    return () => clearInterval(interval);
  }, [currentSlide]); // Dépendance sur currentSlide pour éviter les bugs

  // Revenir en haut de la page après le chargement
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll vers le haut de la page
  }, []); // Le tableau vide [] signifie que cela s'exécute une fois après le premier rendu

  return (
    <div className="overflow-x-hidden">
      <CustomCursor />
      <NavBar />

      {/* Header Carousel - Enhanced */}
      <motion.header
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative h-[600px]"
      >
        <div className="relative w-full h-full overflow-hidden">
          {carouselImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/30 flex justify-center items-center">
                <div className="text-center text-white max-w-4xl px-6">
                  <motion.h1
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="text-3xl md:text-5xl font-bold leading-tight"
                  >
                    COMMENT EST NEE <span className="text-orange-400 block mt-2">PERSPECTIVE CONGO</span>
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="mt-6 text-xl md:text-2xl font-light"
                  >
                    Perspective Congo, depuis sa création en 
                    2007 à  Nantes, se veut être la vitrine du 
                    Congo en France.
                  </motion.p>
                  {/* <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="mt-8 px-8 py-3 bg-orange-400 text-white text-lg rounded-full hover:bg-orange-500 transition-all duration-300 shadow-lg"
                  >
                    Evénement
                  </motion.button> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </motion.header>

      {/* Utilisation du composant FloatingButtons */}
      <BtnFlottant />

      {/* About Section - Enhanced */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-orange-400 via-orange-500 to-pink-500"
      >
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <motion.img
                initial={{ scale: 0.9 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.8 }}
                src={img1}
                className="w-full rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                alt="À propos"
              />
            </div>
            <div className="md:w-1/2 text-white">
              <h2 className="text-4xl font-bold mb-6">Qui sommes-nous ?</h2>
              <p className="text-xl leading-relaxed mb-8">
                En mai 2007 un groupe de Congolais et Français vivant à Nantes ont pensé apporter leur contribution
                à la réalisation de nombreux microprojets de developpement au Congo Brazzaville...
              </p>
              <h3 className="text-3xl font-bold mb-4">Nos objectifs</h3>
              <ul className="space-y-3 text-lg">
                <li className="flex items-center">
                  <span className="mr-2">•</span>
                  Favoriser la formation, l'insertion socioprofessionnnelle des populations défavorisées.
                </li>
                <li className="flex items-center">
                  <span className="mr-2">•</span>
                  Faire appels à des bailleurs de fonds pour des projets de développement.
                </li>
                <li className="flex items-center">
                  <span className="mr-2">•</span>
                  Promouvoir la culture Congolaise.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </motion.section>

      {/* Objectives Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-blue-600 to-indigo-700"
      >
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-white mb-4">Nos objectifs</h2>
          <p className="text-xl text-center mb-12 text-blue-200">
          L’association se déploie sur quatre axes 
          fondamentaux 
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl backdrop-blur-sm p-8 shadow-xl"
            >
              <div className="flex items-center justify-center mb-6">
                <i className="fas fa-briefcase text-orange-400 text-4xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Insertion Socio professionnelle</h3>
              <p className="text-blue-100">
                Concrétement la mise en place se fait par la formation, l'accompagnement et le suivi des jeunes dans leur projet professionnel.
              </p>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl backdrop-blur-sm p-8 shadow-xl"
            >
              <div className="flex items-center justify-center mb-6">
                <i className="fas fa-hands-helping text-orange-400 text-4xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Développement</h3>
              <p className="text-blue-100">
                Nous accompagnons les porteurs de projets dans leur démarche de création d'activité génératrice de revenus.
              </p>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl backdrop-blur-sm p-8 shadow-xl"
            >
              <div className="flex items-center justify-center mb-6">
                <i className="fas fa-users text-orange-400 text-4xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Solidarité</h3>
              <p className="text-blue-100">
                Nous apportons notre soutien aux populations vulnérables à travers des actions de solidarité.
              </p>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white/10 rounded-2xl backdrop-blur-sm p-8 shadow-xl"
            >
              <div className="flex items-center justify-center mb-6">
                <i className="fas fa-globe-africa text-orange-400 text-4xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Culture</h3>
              <p className="text-blue-100">
                Nous promouvons la culture congolaise à travers des événements culturels et artistiques.
              </p>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Strengths Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="py-20 bg-gradient-to-r from-orange-400 to-pink-500"
      >
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-white mb-4">Nos atouts</h2>
          <p className="text-xl text-center mb-12 text-white/90">
            Notre association se fonde sur quatre grands principes...
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              whileHover={{ y: -10 }}
              className="relative rounded-2xl overflow-hidden shadow-2xl group"
            >
              <img src={atout} alt="Nantes" className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/40 flex items-end p-8">
                <p className="text-2xl font-bold text-white">Nantes, une ville ouverte sur le monde</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="relative rounded-2xl overflow-hidden shadow-2xl group"
            >
              <img src={atout1} alt="Convaincre" className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/40 flex items-end p-8">
                <p className="text-2xl font-bold text-white">Convaincre par l'exemple</p>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="relative rounded-2xl overflow-hidden shadow-2xl group"
            >
              <img src={atout2} alt="Unir" className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-black/40 flex items-end p-8">
                <p className="text-2xl font-bold text-white">S'unir autour des projets fédérateurs</p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

          {/* Message du Président - Version améliorée */}
<motion.section
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  className="py-16 md:py-24 bg-gradient-to-r from-blue-600 to-blue-800"
>
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col lg:flex-row gap-10 items-center">
      {/* Conteneur image - Carré parfait */}
      <motion.div 
        initial={{ scale: 0.95 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 0.6 }}
        className="w-full lg:w-1/5 max-w-md aspect-1 rounded-xl shadow-2xl overflow-hidden bg-gray-200"
      >
        <img 
          src={president} 
          alt="Président C. IKAPI - Perspective Congo"
          className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </motion.div>

      {/* Contenu textuel */}
      <div className="w-full lg:w-2/3 text-white space-y-6">
        <motion.h2
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold"
        >
          LE MOT DU PRÉSIDENT
        </motion.h2>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="space-y-6 text-lg leading-relaxed"
        >
          <p className="text-justify">
            Au nom de l'association Perspective Congo, je vous souhaite la bienvenue sur notre site internet. Perspective Congo depuis sa création en 2007 à Nantes, se veut être la vitrine du Congo en Loire-Atlantique. Notre association a pour but de promouvoir le Congo et de créer un pont entre le Congo et la Loire-Atlantique. Nous sommes une association à but non lucratif qui œuvre pour le développement du Congo et la promotion de sa culture.
          </p>

          <div className="mt-8 space-y-1">
            <p className="font-semibold italic">Bonne visite</p>
            <div className="flex items-center gap-2">
              <span className="font-bold">Le président</span>
              <span className="w-8 h-px bg-white/70"></span>
              <span className="text-orange-300 font-bold tracking-wide">C. IKAPI</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </div>
</motion.section>

      <Footer />
    </div>
  );
};

export default Apropos;